import { useEffect } from 'react';

import {
  clearIsRegistrationSuccess,
  clearRegistrationError,
  register,
  registerAndJoinToCourse,
  useSelectIsRegistrationSuccess,
  useSelectRegistrationError
} from 'Auth/data';
import { useAppDispatch } from 'Store';

import type { IRegisterAndJoinToCourseRequest, IRegisterRequest } from '@libs/models';

import { RegistrationForm } from './RegistrationForm';

type Props = {
  joinCode?: string;
};

export const RegistrationFormContainer = ({ joinCode }: Readonly<Props>) => {
  const dispatch = useAppDispatch();
  const registrationError = useSelectRegistrationError();
  const isRegistrationSuccess = useSelectIsRegistrationSuccess();

  const handleSubmit = (values: IRegisterRequest) => {
    if (!joinCode) {
      dispatch(register(values));
    } else {
      dispatch(registerAndJoinToCourse({ ...values, joinCode } as IRegisterAndJoinToCourseRequest));
    }
  };

  useEffect(() => {
    dispatch(clearRegistrationError());
    dispatch(clearIsRegistrationSuccess());
  }, [dispatch]);

  return (
    <RegistrationForm
      onSubmit={handleSubmit}
      error={registrationError as string | null}
      isSubmitSuccess={isRegistrationSuccess as boolean}
    />
  );
};
